import getConfig from 'next/config'

import { ArrowRightIcon } from '@nx/fire/assets'
import { FireButton } from '@nx/fire/button'
import { FireCard } from '@nx/fire/card'
import { Body, Heading } from '@nx/fire/typography'
import { buildDepartmentPath } from '@nx/helpers'
import { getTranslate } from '@nx/translations'
import { useUserInteraction } from '@nx/utils/google-tag-manager'

import {
  ConsignmentPromoContainer,
  StyledFireButton,
} from './ConsignmentPromo.style'
import translate from './ConsignmentPromo.translate.json'

const { text } = getTranslate(translate)
const { publicRuntimeConfig } = getConfig()

export const ConsignmentPromo = ({
  departmentName = '',
  departmentCode,
}: ConsignmentPromoProps) => {
  const { recordInteraction } = useUserInteraction()

  return (
    <ConsignmentPromoContainer>
      <FireCard>
        <Heading
          $level={4}
          as="h2"
          css={`
            margin-bottom: 10px;
          `}
        >
          {text('ownItem.title')}
        </Heading>
        <Body
          css={`
            margin-bottom: 25px;
          `}
        >
          {text('ownItem.body')}
        </Body>
        <FireButton
          href={publicRuntimeConfig.SELL_HUB_BASE_URL}
          onClick={() =>
            recordInteraction({
              action: 'sell-hub-card.click',
              category: 'Lot Page - Own a Similar Item',
              label: '',
            })
          }
        >
          {text('ownItem.cta')}
        </FireButton>
      </FireCard>

      <FireCard>
        <Heading
          $level={4}
          as="h2"
          css={`
            margin-bottom: 10px;
          `}
        >
          {text('lookingForItem.title')}
        </Heading>
        <Body
          css={`
            margin-bottom: 10px;
          `}
        >
          {text('lookingForItem.body', {
            departmentName,
          })}
        </Body>
        <StyledFireButton
          href={
            departmentName && departmentCode
              ? buildDepartmentPath(departmentCode, departmentName)
              : '/people'
          }
          variant="label"
          endIcon={ArrowRightIcon}
        >
          {text('lookingForItem.cta')}
        </StyledFireButton>
      </FireCard>
    </ConsignmentPromoContainer>
  )
}

export interface ConsignmentPromoProps {
  departmentName?: string
  departmentCode?: string
}
